import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/settings/get-donation-categories';

  return API({ endpoint });
}
